import React, { FormEvent, useEffect, useRef, useState } from "react";
import { getAllDrivers } from "../../apis/drivers/get-all-drivers";
import { IDocsDriver } from "../../utils/types";
import DataTable, { TBody, TH, THead, TR } from "../DataTable";
import Modal from "../Modal";
import Pagination from "../Pagination";
import Spinner from "../Spinner";
import { twMerge } from "tailwind-merge";
import Input from '../Input';
import Button from '../Button';

const DriversTable = ({
  isVisible,
  onHide,
  selectedDriver,
  onSelectDriver,
}: {
  isVisible: boolean;
  onHide: () => void;
  selectedDriver: IDocsDriver | null;
  onSelectDriver: (user: IDocsDriver | null) => void;
}) => {
  const [drivers, setDrivers] = useState<IDocsDriver[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const searchForm = useRef<HTMLFormElement>(null);

  const searchRef = useRef("");

  const getUsers = async () => {
    setLoading(true);
    const res = await getAllDrivers({
      page: currentPage,
      search,
    });
    if (res?.success) {
      setDrivers(res?.data?.docs);
      setTotalPages(res?.data?.totalPages);
    }
    setLoading(false);
  };

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    setCurrentPage(1);
    setSearch(searchRef.current);
  };

  useEffect(() => {
    getUsers();
  }, [currentPage, search]);

  return (
    <Modal isVisible={isVisible} onHide={onHide} heading="Select driver">
      <form ref={searchForm} onSubmit={handleSearch} className="mb-4 px-8">
        <div className="flex items-center gap-2 justify-center">
          <Input
            onChange={(e) => (searchRef.current = e.target.value)}
            containerClassName='w-2/3 h-full md:w-auto'
            outerClassName='h-full'
            className="w-full md:w-52 outline-none input-primary h-8 md:h-10 rounded-lg"
            placeholder="search"
          />
          <Button
            type="submit"
            className="w-1/3 md:w-32 min-h-0 h-8 md:h-10"
          >
            Search
          </Button>
        </div>
      </form>

      {loading ? (
        <Spinner />
      ) : !loading && drivers.length === 0 ? (
        <div className='flex justify-center'>
          <p>No driver found </p>
        </div>
      ) : (

        <div className='px-6'>
          <div className='md:block hidden'>
            <DataTable>
              <THead>
                <TR>
                  <TH>Username</TH>
                  <TH>Email</TH>
                  <TH>Phone</TH>
                </TR>
              </THead>
              <TBody>
                {drivers?.map((driver) => (
                  <TR
                    onClick={() => onSelectDriver(driver)}
                    className={twMerge(
                      "cursor-pointer",
                      selectedDriver?._id === driver?._id && "bg-primary"
                    )}
                    key={driver?._id}
                  >
                    <TH className="align-middle  ">
                      <p
                        className={twMerge(
                          "truncate whitespace-nowrap max-w-[180px] text-md text-black font-normal",
                          selectedDriver?._id === driver?._id && "text-white"
                        )}
                      >
                        {driver.fullName}
                      </p>
                    </TH>
                    <TH className="align-middle ">
                      <p
                        className={twMerge(
                          "text-md max-w-[240px] whitespace-nowrap truncate text-black font-normal",
                          selectedDriver?._id === driver?._id && "text-white"
                        )}
                      >
                        {driver.email}
                      </p>
                    </TH>
                    <TH
                      className={twMerge(
                        "align-middle text-black font-normal whitespace-nowrap",
                        selectedDriver?._id === driver?._id && "text-white"
                      )}
                    >
                      {driver.phone}
                    </TH>
                  </TR>
                ))}
              </TBody>
            </DataTable>
          </div>


          <div className="block md:hidden">
            {drivers?.map((driver) => (
              <div
                key={driver?._id}
                onClick={() => onSelectDriver(driver)}
                className={twMerge(
                  "cursor-pointer p-4 mb-2 rounded-lg shadow-sm border border-gray-100 bg-white flex flex-col gap-1",
                  selectedDriver?._id === driver?._id && "bg-primary border-primary"
                )}
              >
                <p className={twMerge(
                  "font-semibold text-sm truncate",
                  selectedDriver?._id === driver?._id ? "text-white" : "text-black"
                )}>
                  {driver.fullName}
                </p>
                <p className={twMerge(
                  "text-sm truncate",
                  selectedDriver?._id === driver?._id ? "text-white" : "text-gray-500"
                )}>
                  {driver.email}
                </p>
                <p className={twMerge(
                  "text-sm",
                  selectedDriver?._id === driver?._id ? "text-white" : "text-gray-500"
                )}>
                  {driver.phone}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-4">
            <Pagination
              currentPage={currentPage}
              page={totalPages}
              handlePageClick={(e: { selected: number }) =>
                setCurrentPage(e.selected + 1)
              }
            />
          </div>
        </div>

      )}



      <div className="col-start-1 col-end-3 flex justify-end mt-6 mr-3">
        <Button
          disabled={selectedDriver === null}
          onClick={onHide}
          className="w-32 min-h-0 h-10 md:h-10"
        >
          Save
        </Button>
      </div>

    </Modal>
  );
};

export default DriversTable;
